export const styles = () => ({
  bigFont: {
    fontSize: 26,
  },
});
